<template>
  <div class="product-options-style">
    <div class="setting-item clearFloat">
      <el-popover
        ref="previewPopover"
        popper-class="previewPopover"
        placement="left"
        title=""
        trigger="hover"
        :visible-arrow="false"
        :disabled="disablePreview"
      >
        <img style="width: 100%; height: 100%" :src="previewSrc" />
        <div slot="reference" class="content">
          <swiper :options="swiperOptions" v-if="swiperLen > 0">
            <swiper-slide v-for="idx in swiperLen" :key="idx">
              <ul class="product-styles">
                <li
                  class="product-style-item"
                  v-for="(style, index) in productStyles.slice(
                    showLen * (idx - 1),
                    showLen * idx > productStyles.length ? productStyles.length : showLen * idx
                  )"
                  :class="
                    selectId === style.id
                      ? 'active'
                      : ''
                  "
                  :key="index"
                >
                  <div
                    class="product-img-box"
                    @click="changeproductStyle(style)"
                    @mouseenter="setMouseEnter"
                    @mouseout="setMouseOut"
                  >
                    <img
                      :src="style.cover ? style.cover : style.cover ? style.cover : defaultImg"
                      alt=""
                    />
                    <i class="icon-checked" v-if="request_prefix !== 'bigScreen'"></i>
                  </div>
                  <p class="fs14 overflowHid1">{{ style.name }}</p>
                </li>
              </ul>
            </swiper-slide>
          </swiper>
          <div class="swiper-button swiper-button-prev" v-if="productStyles.length > showLen"></div>
          <div class="swiper-button swiper-button-next" v-if="productStyles.length > showLen"></div>
        </div>
      </el-popover>
    </div>
    <!-- <styles-list
      v-if="showAllStyle"
      :showDialog.sync="showAllStyle"
      :typeId="typeId"
      :styleTypeName="styleTypeName"
      :localStylesLen="localStylesLen"
      :allStyles="productStyles"
      styleType="product"
      :activeIndex="activeIndex"
      :options="options"
      @changeStyle="changeproductStyle"
    ></styles-list> -->
  </div>
</template>

<script>
import stylesList from "components/toolbar-option-components/styles/styles-list"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"

export default {
  name: "product-options-style",
  components: {
    stylesList,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    selectId: undefined,
    styleOptions: {
      type: Object
    },
    productStyles: Array
  },
  computed: {
    // productStyles: {
    //   get() {
    //     let menu =
    //       this.request_prefix === "bigScreen"
    //         ? this.$store.state.bigScreenMenu.menu
    //         : this.request_prefix === "appStage"
    //         ? this.$store.state.appMenu.menu
    //         : this.$store.state.menu.menu
    //     let styles = [],
    //       productStyles = [],
    //       cover = "",
    //       isElement = false
    //     for (let i = 0; i < menu.children.length; i++) {
    //       if (
    //         menu.children[i].type === "element" ||
    //         menu.children[i].type === "highLevel" ||
    //         menu.children[i].type === "baseElement"
    //       ) {
    //         for (let j = 0; j < menu.children[i].children.length; j++) {
    //           if (menu.children[i].children[j].typeId === this.typeId) {
    //             styles = menu.children[i].children[j].children
    //             this.styleTypeName = menu.children[i].children[j].name
    //             this.localStylesLen = menu.children[i].children[j].localStylesLen
    //             cover = menu.children[i].children[j].cover
    //             isElement = true
    //             break
    //           }
    //         }
    //       }
    //     }
    //     if (styles.length < 1) {
    //       // 请求接口
    //       // this.getProductStyles()
    //     }
    //     styles.forEach((item, index) => {
    //       productStyles.push({
    //         options: item.attribute?.options,
    //         name: item.name,
    //         cover: !item.cover && item.thumbnail ? cover : item.cover, // 针对按钮的本地样式的cover处理
    //         encId: item.attribute?.options.encId
    //       })
    //     })
    //     return productStyles
    //   },
    //   set() {}
    // },
    showStyles() {
      return this.productStyles.length > this.showLen ? this.productStyles.slice(0, this.showLen) : this.productStyles
    },
    moreStyles() {
      return this.productStyles.length > this.showLen ? this.productStyles.slice(this.showLen) : []
    },
    swiperLen() {
      return Math.ceil(this.productStyles.length / this.showLen)
    }
  },
  data() {
    return {
      defaultImg: require("@/assets/images/default_image_home.png"),
      activeIndex: 0,
      activeNames: [],
      showLen: 4,
      styleImgs: [],
      showAllStyle: false,
      styleTypeName: "",
      localStylesLen: 0,
      swiperOptions: {
        loop: false,
        speed: 500,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button.swiper-button-next",
          prevEl: ".swiper-button.swiper-button-prev"
        }
      },
      previewSrc: "",
      disablePreview: true
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    async changeproductStyle(style, index, idx) {
      // this.handleDefaultAnimate(style)
      this.$emit("update:selectId", style.id)
      this.$emit("select", style.id)
      
    },
    //  目前只做了按钮的切换样式保留动画，因为按钮可以收藏，所以不在local-style
    /**
     *
     * @param {*} listPageId
     * 由于有些样式不存在更多组件，所以用try catch
     */
    showAllStyles() {
      this.showAllStyle = true
    },
    setMouseEnter(ev) {
      this.disablePreview = false
      const img = ev.target.children[0],
        width = img.naturalWidth,
        height = img.naturalHeight,
        previewPopover = document.getElementsByClassName("previewPopover")[0],
        baseSize = 616
      this.previewSrc = img.src
      if (width && height) {
        if (width > height) {
          previewPopover.style.width = `${baseSize}px`
          previewPopover.style.height = `${parseInt((height / width) * baseSize)}px`
        } else {
          previewPopover.style.height = `${baseSize}px`
          previewPopover.style.width = `${parseInt((width / height) * baseSize)}px`
        }
      } else {
        previewPopover.style.width = `${baseSize}px`
        previewPopover.style.height = `${baseSize}px`
      }
      previewPopover.style.padding = "8px"
      previewPopover.style.borderRadius = 0
      previewPopover.style.boxShadow = "0px 6px 24px 0px rgba(31, 35, 41, 0.1)"
      previewPopover.style.border = "1px solid rgba(233, 233, 233, 1)"
      this.$refs.previewPopover.updatePopper()
    },
    setMouseOut(ev) {
      if (
        !ev.toElement.className.includes("product-img-box") &&
        !ev.toElement.parentElement.className.includes("product-img-box")
      ) {
        this.disablePreview = true
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.product-styles {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  gap: 12px;
  p {
    margin-bottom: 0;
    color: var(--textColor);
    line-height: 18px;
    font-size: 13px;
  }
  .product-img-box {
    position: relative;
    height: 85px;
    border-radius: 4px;
    background: var(--editBgColor);
    text-align: center;
    box-sizing: border-box;
    overflow: hidden;
    padding: 8px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .delete-icon {
      position: absolute;
      display: none;
      bottom: 2px;
      right: 2px;
      border-radius: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background-color: var(--iconHoverBgColor);
      color: var(--iconColor);
    }
    .icon-checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      background-image: url(../../../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      display: none;
    }
    &:hover {
      .delete-icon {
        display: block;
      }
    }
  }
  .product-style-item {
    width: 108px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 4px;
    &.active {
      .product-img-box {
        box-shadow: 0 0 0 2px var(--themeColor) inset;
        .icon-checked {
          display: block;
        }
      }
    }
    &:not(.active) .product-img-box:hover {
      box-shadow: 0 0 0 2px var(--themeColorDisabled) inset;
    }
    &:not(.active) .product-img-box {
      box-shadow: 0 0 0 1px var(--elCollapseItemBorderColor) inset;
    }
  }
  .product-item {
    width: 100%;
    border: none;
    padding: 0;
    cursor: pointer;
  }
}
.product-options-style {
  padding: 16px;
}
.product-options-style .content {
  position: relative;
}
.product-options-style:hover .swiper-button {
  display: block;
}
.swiper-button {
  width: 14px;
  height: 46px;
  line-height: 45px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 0px 2px 2px 0px;
  color: var(--subTextColor);
  margin-top: -48px;
  display: none;
}
.swiper-button::after {
  font-size: 12px;
}
.swiper-button-prev {
  left: -14px;
}
.swiper-button-next {
  right: -14px;
}
</style>
